<div class="max-w-7xl mx-auto bg-white/60 p-3 rounded-lg">
  <div class="flex flex-wrap items-end justify-between mb-8 px-1">
    <div class="flex items-center gap-4">
      <div class="rounded-full bg-gradient-to-br from-blue-800 via-blue-700 to-blue-600 shadow-lg p-2 flex items-center justify-center">
        <i class="pi pi-bell text-white text-xl"></i>
      </div>
      <div>
        <h1 class="text-2xl font-black text-slate-900 tracking-tight mb-0.5 drop-shadow-sm">Notification Center</h1>
        <p class="text-xs font-semibold text-slate-500 uppercase tracking-widest leading-tight">WORKSPACE UPDATES</p>
      </div>
    </div>
    <!-- <div class="flex flex-col items-end min-w-[11rem] gap-2">
      <span class="text-[11px] font-semibold text-blue-900/70 tracking-wide uppercase">Storage Utilization</span>
      <div class="relative w-40 h-3 bg-slate-50 rounded shadow-inner border border-slate-200 overflow-hidden transition-all">
        <div class="absolute left-0 top-0 h-full bg-gradient-to-r from-blue-700 via-blue-400 to-cyan-400 rounded transition-all duration-500" style="width:65%"></div>
        <span class="absolute right-3 top-1/2 -translate-y-1/2 text-[11px] font-bold text-blue-700/80 tracking-wider">65%</span>
      </div>
      <span class="text-[9px] text-slate-400 italic">You have used 65% of your allotted storage</span>
    </div> -->
  </div>

  <div class="flex items-center gap-1 bg-slate-200/60 p-1 rounded-xl w-fit mb-3 border border-slate-200/50 shadow-inner">
    <button 
      (click)="switchTab('inbox')"
      [ngClass]="activeTab === 'inbox' 
        ? 'bg-white text-blue-600 shadow-sm shadow-blue-200/50 ring-1 ring-black/5' 
        : 'text-slate-500 hover:text-slate-700 hover:bg-white/40'"
      class="flex items-center gap-2.5 px-6 py-2 rounded-lg text-xs font-bold transition-all duration-200 outline-none">
      <i class="pi pi-inbox text-sm"></i>
      <span>Inbox</span>
      <span *ngIf="unreadCount > 0" 
        class="flex items-center justify-center min-w-[18px] h-[18px] px-1 bg-blue-600 text-white text-[9px] font-black rounded-md shadow-sm">
        {{ unreadCount }}
      </span>
    </button>

    <button 
      (click)="switchTab('outbox')"
      [ngClass]="activeTab === 'outbox' 
        ? 'bg-white text-blue-600 shadow-sm shadow-blue-200/50 ring-1 ring-black/5' 
        : 'text-slate-500 hover:text-slate-700 hover:bg-white/40'"
      class="flex items-center gap-2.5 px-6 py-2 rounded-lg text-xs font-bold transition-all duration-200 outline-none">
      <i class="pi pi-send text-sm"></i>
      <span>Outbox</span>
    </button>
  </div>

  <div class=" mx-auto bg-white shadow-lg rounded-xl overflow-hidden border border-slate-200">
    
  
    <div class="divide-y divide-slate-100 max-h-[700px] overflow-y-auto bg-white">
      <div *ngFor="let msg of (activeTab === 'inbox' ? inboxMessages : outboxMessages); let i = index"
        class="group flex flex-col transition-all duration-200 hover:bg-slate-50 cursor-pointer"
        [ngClass]="{'bg-blue-50/40 border-l-4 border-l-blue-600': msg.status === 'unread'}">
        
        <div class="flex items-center gap-4 px-6 py-4" (click)="msg.isExpanded = !msg.isExpanded; markAsRead(msg)">
          
          <div class="shrink-0">
            <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold text-xs border border-blue-200">
              {{ msg.sender.first_name[0] }}{{ msg.sender.last_name[0] }}
            </div>
          </div>
  
          <div class="w-1/4 shrink-0 overflow-hidden">
            <p class="text-sm truncate capitalize"
               [ngClass]="{'font-bold text-slate-900': msg.status === 'unread', 'font-medium text-slate-600': msg.status !== 'unread'}">
              {{ msg.sender.first_name }} {{ msg.sender.last_name }}
            </p>
            <p class="text-[11px] text-slate-400 font-medium truncate uppercase tracking-wider">
              {{ msg.sender.unit.code }} • {{ msg.sender.rankName }}
            </p>
          </div>
  
          <div class="flex-1 overflow-hidden">
            <p class="text-sm truncate"
               [ngClass]="{'font-semibold text-slate-800': msg.status === 'unread', 'text-slate-500': msg.status !== 'unread'}">
              <span class="text-blue-600 mr-1">[{{ msg.notification_type_display }}]</span>
              {{ msg.title }}
            </p>
            <p class="text-xs text-slate-400 truncate mt-0.5">
              {{ msg.message }}
            </p>
          </div>
  
          <div class="flex items-center gap-4 shrink-0">
            <span class="text-[11px] font-semibold text-slate-400">
              {{ msg.created_on | date: 'MMM d, h:mm a' }}
            </span>
            <i class="pi text-[10px] text-slate-400 transition-transform duration-300"
               [ngClass]="msg.isExpanded ? 'rotate-180' : ''" class="pi-chevron-down"></i>
          </div>
        </div>
  
        <div *ngIf="msg.isExpanded" class="px-6 pb-6 pt-2 animate-in fade-in slide-in-from-top-1 duration-200">
          <div class="p-6 bg-white rounded-xl border border-slate-200 shadow-sm ml-14">
            
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 pb-6 border-b border-slate-100">
              
              <div class="flex flex-col gap-2">
                <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">From</span>
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 rounded bg-slate-100 flex items-center justify-center text-slate-600 font-bold text-xs">
                    {{ msg.sender.rankCode }}
                  </div>
                  <div>
                    <p class="text-sm font-bold text-slate-800">{{ msg.sender.first_name }} {{ msg.sender.last_name }}</p>
                    <p class="text-[11px] text-slate-500">{{ msg.sender.rankName }} | {{ msg.sender.unit.name }} ({{ msg.sender.unit.code }})</p>
                    <p class="text-[11px] text-blue-600 italic">{{ msg.sender.email }}</p>
                  </div>
                </div>
              </div>
        
              <div class="flex flex-col gap-2">
                <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">To (Receiver)</span>
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 rounded bg-blue-50 flex items-center justify-center text-blue-600 font-bold text-xs border border-blue-100">
                    {{ msg.receiver.rankCode }}
                  </div>
                  <div>
                    <p class="text-sm font-bold text-slate-800">{{ msg.receiver.first_name }} {{ msg.receiver.last_name }}</p>
                    <p class="text-[11px] text-slate-500">{{ msg.receiver.rankName }} | {{ msg.receiver.unit.name }}</p>
                    <p class="text-[11px] text-blue-600 italic">{{ msg.receiver.email }}</p>
                  </div>
                </div>
              </div>
            </div>
        
            <div class="mb-6">
              <h3 class="text-sm font-bold text-slate-900 mb-2">{{ msg.title }}</h3>
              <div class="p-4 bg-slate-50 rounded-lg border border-slate-100">
                <p class="text-sm text-slate-700 leading-relaxed italic blockquote">
                  "{{ msg.message }}"
                </p>
              </div>
            </div>
        
            <div class="flex items-center justify-between pt-4 border-t border-slate-50">
              <div class="flex gap-4">
                <div class="text-[10px] text-slate-400">
                  <span class="font-bold">Role:</span> {{ msg.sender.roles[0].name }}
                </div>
                <div class="text-[10px] text-slate-400">
                  <span class="font-bold">Sent via:</span> {{ msg.sender.modified_ip }}
                </div>
              </div>
              
              <div class="flex gap-2">
                <button class="px-4 py-2 text-[11px] font-bold text-slate-600 border border-slate-200 rounded-lg hover:bg-slate-50">
                  Archive
                </button>
                <button (click)="$event.stopPropagation(); onViewNotification(msg)"
                    class="px-5 py-2 text-[12px] font-bold bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all active:scale-95">
                    Open Proposal <i class="pi pi-external-link ml-2 text-[10px]"></i>
                </button>
                <button *ngIf="msg?.context_data?.module === 'seek_proposal'" (click)="$event.stopPropagation(); openNilCommentPopup(msg)"
  class="px-5 py-2 text-[12px] font-bold bg-blue-600 text-white rounded-lg hover:bg-blue-700 shadow-lg shadow-blue-200 transition-all active:scale-95">
  Send Nil Returns
</button>
              </div>
            </div>
          </div>
        </div>
  
      </div>
    </div>
  </div>
</div>


<p-dialog 
  header="Send Nil Returns"
  [(visible)]="showNilPopup"
  [modal]="true"
  [closable]="true"
  [style]="{width: '600px'}"
  [draggable]="false"
>

  <div class="flex flex-col gap-3">
    <label class="font-semibold text-blue-600">Remark:</label>

    <textarea
      rows="5"
      pInputTextarea
      [(ngModel)]="nilRemark"
      placeholder="Enter your remarks..."
      class="w-full border rounded p-2">
    </textarea>
  </div>

  <ng-template pTemplate="footer">
    <button 
      pButton 
      label="Cancel" 
      class="p-button-text"
      (click)="showNilPopup=false">
    </button>

    <button 
      pButton 
      label="Send"
      class="p-button-success"
      (click)="confirmNilAction()">
    </button>
  </ng-template>

</p-dialog>